import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportLampsToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8687_26860)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18.7497 7.1716V17.4997C18.7497 18.19 18.19 18.7497 17.4997 18.7497H2.5C1.80964 18.7497 1.25 18.19 1.25 17.4997V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H12.8281",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.75 1.25155L7.61385 12.3877",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.61328 6.02295L7.61328 12.3865H13.9768",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8687_26860",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgImportLampsToolbar;
